export var FeatureToggle;
(function (FeatureToggle) {
    FeatureToggle["Reviews"] = "reviews";
    FeatureToggle["Loyalty"] = "loyalty";
    FeatureToggle["OrderAgain"] = "orderAgain";
    FeatureToggle["GiftCards"] = "giftCard";
    FeatureToggle["Catering"] = "catering";
})(FeatureToggle || (FeatureToggle = {}));
//# sourceMappingURL=types.js.map